import { Box, styled } from '@mui/material';

export const CreateRotationSectionsGridContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 30px;
  position: relative;
`;

export const RotationSectionsLayoutBuilder = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
`;
export const RotationSectionsDefaultLayout = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  margin-right: 5em;
`;
